import NotificationCard from "../../components/mainComponents/NotificationCard";
import classes from "./Notification.module.css";
import { useState, useEffect } from "react";
import refreshToken from "../../functions/refreshToken";
import checkToken from "../../functions/checkToken";
import { useLocation, useNavigate } from "react-router-dom";
import svgBack from "../../assets/SVGs/back.svg";
import notificationCardClasses from "../../components/mainComponents/NotificationCard.module.css";
import toast from "react-hot-toast";

function Notification() {
  const navigate = useNavigate();
  const [loadedData, setLoadedData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    async function loadData() {
      try {
        const token = localStorage.getItem("token");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/admin/notification`,
          requestOptions
        );
        const result = await response.json();
        setLoadedData(result.notifications);
        setIsLoaded(true);
      } catch (error) {
        try {
          const parsedError = JSON.parse(error.message);
          if (parsedError && parsedError.error) {
            toast.error(parsedError.error.description || "خطا در اتصال شبکه");
          } else {
            toast.error("خطا در اتصال شبکه");
          }
        } catch (e) {
          toast.error("خطا در اتصال شبکه");
        }
      }
    }

    loadData();
    refreshToken();
    checkToken();
  }, []);

  return (
    <div style={{ direction: "rtl" }} className={classes.main}>
      <div style={{ direction: "ltr" }} className={classes.header}>
        <div className={classes.return} onClick={() => navigate(-1)}>
          <img src={svgBack} className={classes.svg} alt="Back" />
        </div>
      </div>
      <div className={classes.cardContainer}>
        {isLoaded ? (
          loadedData.map((item) => (
            <div
              key={item.id}
              className={notificationCardClasses.cardContainer}
            >
              <div className={notificationCardClasses.info}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h5>{item.title}</h5>
                  <p
                    style={{
                      marginRight: "auto",
                      fontSize: "12px",
                      fontStyle: "normal",
                      padding: "10px",
                      color: "#182d7a",
                    }}
                  >
                    {item.created_date.split(" ")[0]}
                  </p>
                </div>
                <p className={notificationCardClasses.text}>
                  {item.description}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            لطفا منتظر بمانید ...
          </p>
        )}
      </div>
    </div>
  );
}

export default Notification;
